namespace $.$$ {

	$mol_style_define( $.$hyoo_intern_person_card_profile, {
		
		flex: {
			wrap: 'wrap',
		},

		Avatar: {
			background: {
				color: $mol_theme.card,
			},
			margin: {
				right: $mol_gap.block,
			}
		},
		
		Name_sub: {
			color: $mol_theme.shade,
		},

	} )

}
